// Belfiore Z-code → ISO 3166-1 alpha-2 mapping for foreign countries.
//
// The Italian Codice Fiscale encodes the birthplace in chars 12-15
// (the "Belfiore code"). Codes starting with "Z" + 3 digits refer to
// FOREIGN countries. We map them here to the ISO 3166-1 alpha-2 codes
// so we can auto-tick "Nato all'estero" + preselect the country when
// an Italian citizen born abroad enters a valid CF.
//
// SOURCE OF TRUTH: this mapping is auto-generated from the
// `python-codicefiscale` library's own ANPR-based dataset by
// `backend/scripts/regen_country_data.py`. DO NOT hand-edit — regen
// after each library upgrade.
//
// Fabrizio bug 24/07/2026 (Bohdan Slutinsky test): the previous
// hand-maintained table had ~30 wrong entries (e.g. Z139 → LV instead
// of BY, Z107 → FR instead of DK). This full rebuild eliminates the
// class of bug entirely.

const BELFIORE_FOREIGN_TO_ISO = {
  "Z100": "AL", // Albania
  "Z101": "AD", // Andorra
  "Z102": "AT", // Austria
  "Z103": "BE", // Belgio
  "Z104": "BG", // Bulgaria
  "Z106": "VA", // Stato Città del Vaticano
  "Z107": "DK", // Danimarca
  "Z109": "FI", // Finlandia
  "Z110": "FR", // Francia
  "Z112": "DE", // Germania
  "Z114": "GB", // Regno Unito
  "Z115": "GR", // Grecia
  "Z116": "IE", // Irlanda
  "Z117": "IS", // Islanda
  "Z119": "LI", // Liechtenstein
  "Z120": "LU", // Lussemburgo
  "Z121": "MT", // Malta
  "Z123": "MC", // Monaco
  "Z125": "NO", // Norvegia
  "Z126": "NL", // Paesi Bassi
  "Z127": "PL", // Polonia
  "Z128": "PT", // Portogallo
  "Z129": "RO", // Romania
  "Z130": "SM", // San Marino
  "Z131": "ES", // Spagna
  "Z132": "SE", // Svezia
  "Z133": "CH", // Svizzera
  "Z134": "HU", // Ungheria
  "Z138": "UA", // Ucraina
  "Z139": "BY", // Bielorussia  ← FIX Bohdan bug 24/07/2026
  "Z140": "MD", // Moldova
  "Z144": "EE", // Estonia
  "Z145": "LV", // Lettonia
  "Z146": "LT", // Lituania
  "Z148": "MK", // Macedonia del Nord
  "Z149": "HR", // Croazia
  "Z150": "SI", // Slovenia
  "Z153": "BA", // Bosnia-Erzegovina
  "Z154": "RU", // Federazione Russa
  "Z155": "SK", // Slovacchia
  "Z156": "CZ", // Repubblica Ceca
  "Z158": "RS", // Serbia
  "Z159": "ME", // Montenegro
  "Z200": "AF", // Afghanistan
  "Z203": "SA", // Arabia Saudita
  "Z204": "BH", // Bahrein
  "Z205": "BT", // Bhutan
  "Z206": "MM", // Myanmar
  "Z207": "BN", // Brunei
  "Z208": "KH", // Cambogia
  "Z209": "LK", // Sri Lanka
  "Z210": "CN", // Repubblica Popolare Cinese
  "Z211": "CY", // Cipro
  "Z213": "KR", // Repubblica di Corea
  "Z214": "KP", // Repubblica Popolare Democratica di Corea
  "Z215": "AE", // Emirati Arabi Uniti
  "Z216": "PH", // Filippine
  "Z219": "JP", // Giappone
  "Z220": "JO", // Giordania
  "Z222": "IN", // India
  "Z223": "ID", // Indonesia
  "Z224": "IR", // Iran
  "Z225": "IQ", // Iraq
  "Z226": "IL", // Israele
  "Z227": "KW", // Kuwait
  "Z228": "LA", // Laos
  "Z229": "LB", // Libano
  "Z232": "MV", // Maldive
  "Z233": "MN", // Mongolia
  "Z234": "NP", // Nepal
  "Z235": "OM", // Oman
  "Z236": "PK", // Pakistan
  "Z237": "QA", // Qatar
  "Z240": "SY", // Siria
  "Z241": "TH", // Thailandia
  "Z242": "TL", // Timor Orientale
  "Z243": "TR", // Turchia
  "Z246": "YE", // Yemen
  "Z247": "MY", // Malaysia
  "Z248": "SG", // Singapore
  "Z249": "BD", // Bangladesh
  "Z251": "VN", // Vietnam
  "Z252": "AM", // Armenia
  "Z253": "AZ", // Azerbaigian
  "Z254": "GE", // Georgia
  "Z255": "KZ", // Kazakhstan
  "Z256": "KG", // Kirghizistan
  "Z257": "TJ", // Tagikistan
  "Z258": "TM", // Turkmenistan
  "Z259": "UZ", // Uzbekistan
  "Z300": "NA", // Namibia
  "Z301": "DZ", // Algeria
  "Z302": "AO", // Angola
  "Z305": "BI", // Burundi
  "Z306": "CM", // Camerun
  "Z307": "CV", // Capo Verde
  "Z308": "CF", // Repubblica Centrafricana
  "Z309": "TD", // Ciad
  "Z310": "KM", // Comore
  // Z311 is used by ISTAT for both Congo (Rep.) and DR Congo — modern
  // registration defaults to the Republic of Congo (CG). Zaire/DRC (CD)
  // has its own historical code but the library keeps them fused here.
  "Z311": "CG", // Congo
  "Z313": "CI", // Costa d'Avorio
  "Z314": "BJ", // Benin
  "Z315": "ET", // Etiopia
  "Z316": "GA", // Gabon
  "Z317": "GM", // Gambia
  "Z318": "GH", // Ghana
  "Z319": "GN", // Guinea
  "Z320": "GW", // Guinea-Bissau
  "Z321": "GQ", // Guinea Equatoriale
  "Z322": "KE", // Kenya
  "Z325": "LR", // Liberia
  "Z326": "LY", // Libia
  "Z327": "MG", // Madagascar
  "Z328": "MW", // Malawi
  "Z329": "ML", // Mali
  "Z330": "MA", // Marocco
  "Z331": "MR", // Mauritania
  "Z332": "MU", // Mauritius
  "Z333": "MZ", // Mozambico
  "Z334": "NE", // Niger
  "Z335": "NG", // Nigeria
  "Z336": "EG", // Egitto
  "Z337": "ZW", // Zimbabwe
  "Z338": "RW", // Ruanda
  "Z341": "ST", // Sao Tomé e Principe
  "Z342": "SC", // Seychelles
  "Z343": "SN", // Senegal
  "Z344": "SL", // Sierra Leone
  "Z345": "SO", // Somalia
  "Z347": "ZA", // Sud Africa
  "Z348": "SD", // Sudan
  "Z349": "SZ", // Eswatini
  "Z351": "TG", // Togo
  "Z352": "TN", // Tunisia
  "Z353": "UG", // Uganda
  "Z354": "BF", // Burkina Faso
  "Z355": "ZM", // Zambia
  "Z357": "TZ", // Tanzania
  "Z358": "BW", // Botswana
  "Z359": "LS", // Lesotho
  "Z361": "DJ", // Gibuti
  "Z368": "ER", // Eritrea
  "Z401": "CA", // Canada
  "Z404": "US", // Stati Uniti d'America
  "Z502": "BS", // Bahamas
  "Z503": "CR", // Costa Rica
  "Z504": "CU", // Cuba
  "Z505": "DO", // Repubblica Dominicana
  "Z506": "SV", // El Salvador
  "Z507": "JM", // Giamaica
  "Z509": "GT", // Guatemala
  "Z510": "HT", // Haiti
  "Z511": "HN", // Honduras
  "Z512": "BZ", // Belize
  "Z514": "MX", // Messico
  "Z515": "NI", // Nicaragua
  "Z516": "PA", // Panama
  "Z522": "BB", // Barbados
  "Z524": "GD", // Grenada
  "Z526": "DM", // Dominica
  "Z527": "LC", // Saint Lucia
  "Z528": "VC", // Saint Vincent e Grenadine
  "Z532": "AG", // Antigua e Barbuda
  "Z533": "KN", // Saint Kitts e Nevis
  "Z600": "AR", // Argentina
  "Z601": "BO", // Bolivia
  "Z602": "BR", // Brasile
  "Z603": "CL", // Cile
  "Z604": "CO", // Colombia
  "Z605": "EC", // Ecuador
  "Z606": "GY", // Guyana
  "Z608": "SR", // Suriname
  "Z610": "PY", // Paraguay
  "Z611": "PE", // Perù
  "Z612": "TT", // Trinidad e Tobago
  "Z613": "UY", // Uruguay
  "Z614": "VE", // Venezuela
  "Z700": "AU", // Australia
  "Z704": "FJ", // Figi
  "Z711": "MH", // Isole Marshall
  "Z713": "NR", // Nauru
  "Z719": "NZ", // Nuova Zelanda
  "Z724": "SB", // Isole Salomone
  "Z726": "WS", // Samoa
  "Z728": "TO", // Tonga
  "Z730": "PG", // Papua Nuova Guinea
  "Z731": "KI", // Kiribati
  "Z732": "TV", // Tuvalu
  "Z733": "VU", // Vanuatu
  "Z734": "PW", // Palau
  "Z735": "FM", // Stati Federati di Micronesia
  "Z907": "SS", // Sud Sudan
};

/**
 * Return the ISO 3166-1 alpha-2 country code for a Belfiore foreign
 * code (e.g. "Z139" → "BY"), or null if the input is not a foreign
 * Belfiore code (Italian comune codes A-Y, unknown codes).
 *
 * @param {string} belfioreCode e.g. "Z428"
 * @returns {string|null}
 */
export const belfioreToIsoCountry = (belfioreCode) => {
  if (!belfioreCode) return null;
  const code = String(belfioreCode).trim().toUpperCase();
  if (!/^Z\d{3}$/.test(code)) return null;
  return BELFIORE_FOREIGN_TO_ISO[code] || null;
};

/**
 * Extract the Belfiore code from a Codice Fiscale (chars 12-15,
 * 1-indexed positions 12-15 → 0-indexed slice [11:15]) and, if it's
 * a foreign Z-code, return the corresponding ISO 3166-1 alpha-2 code.
 *
 * @param {string} cf 16-char Italian Codice Fiscale
 * @returns {string|null} ISO country code (e.g. "BY") or null
 */
export const deriveForeignBirthCountryFromCF = (cf) => {
  if (!cf) return null;
  const code = String(cf).trim().toUpperCase().replace(/\s/g, "");
  if (code.length !== 16) return null;
  const belfiore = code.substring(11, 15);
  return belfioreToIsoCountry(belfiore);
};

export default BELFIORE_FOREIGN_TO_ISO;
